/*
 * The real browser bootstrap. src/main.ts is deliberately a ONE-LINE dynamic import of this file
 * (Baruch 2026-10-22, docs/agents/deployment.md "Chunk churn"): esbuild keeps every module that the
 * entry file reaches statically INSIDE the entry chunk, and the lazy routes then import their shared
 * code FROM main - so any lazy change renamed main and the ~110 chunks importing it. With nothing
 * statically reachable from main, shared code lands in shared chunks and a lazy change renames 3
 * files (measured: 3 of 206 vs 121 of 170). NEVER add a static import to main.ts.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppBrowserModule } from './app/app.browser.module';
import { environment } from './environments/environment';

/*
Add VERSION of this build to the deployUrl:
with this - the links to lazy loaded files get versioning in order to pass proxy caching and browser cache.
for this to work:
1. Make shure to have rewrite rule in the server to remove /version/x.y.z/ from path
2. Have npm script that update your app version on prod build and write the version to a version file in environments
*/

if (environment.production) {
    enableProdMode();
}

// document.addEventListener('DOMContentLoaded', () => {
// The following not needed anymore, but kept for reference sincev we delete the state from esi in server.ts
// // Due to Esi merging we ended up with multiple states from the server, thus we need to merge them into
// //  one inner script, we can't split them because then the data would be in a different cache and re-request.
// let statesArr = document.querySelectorAll('[id=AngularApp-state]');
// let statesCount = statesArr.length;
// // Only in Varnish in varnish there are more than 1 not in direct or development
// if (statesCount > 1) {
//     // Get the states inner HTML
//     let innerHtmls = [];
//     for (let index = 0; index < statesCount; index++) {
//         innerHtmls.push(statesArr[index].innerHTML);
//     }
//     let finalJson = [];
//     for (let index = 0; index < statesCount - 1; index++) {
//         document.getElementById('AngularApp-state').remove();
//         // In the fierst iteration we want to start with '{' while in the other it get replaced with ','
//         let startingDigit = index === 0 ? 0 : 1;
//         finalJson.push(innerHtmls[index].substring(startingDigit, innerHtmls[index].length - 1));
//         finalJson.push(',');
//     }
//     let lastHtmls = innerHtmls[statesCount - 1];
//     finalJson.push(lastHtmls.substring(1, lastHtmls.length));
//     document.getElementById('AngularApp-state').innerHTML = finalJson.join('');
// }
// });
platformBrowser()
    .bootstrapModule(AppBrowserModule)
    .catch((err) => console.log(err));
